var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataSource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 149,
    viewBox: "0 0 201 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1105_13150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1105_13150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.974 19.3354C188.991 19.1824 189 19.0289 189 18.875C189 8.45063 149.377 0 100.5 0C51.6228 0 12 8.45063 12 18.875C12 19.0289 12.0086 19.1824 12.0258 19.3354H12V105.424V106.805H12.2333C15.5495 116.584 53.8007 124.299 100.5 124.299C147.199 124.299 185.45 116.584 188.767 106.805H189V105.424V19.3354H188.974Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.974 19.3354C188.991 19.1824 189 19.0289 189 18.875C189 8.45063 149.377 0 100.5 0C51.6228 0 12 8.45063 12 18.875C12 19.0289 12.0086 19.1824 12.0258 19.3354H12V105.424V106.805H12.2333C15.5495 116.584 53.8007 124.299 100.5 124.299C147.199 124.299 185.45 116.584 188.767 106.805H189V105.424V19.3354H188.974Z",
    fill: "#FEEE95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.974 19.3354L186.987 19.1124L186.737 21.3354H188.974V19.3354ZM12.0258 19.3354V21.3354H14.2628L14.0133 19.1123L12.0258 19.3354ZM12 19.3354V17.3354H10V19.3354H12ZM12 106.805H10V108.805H12V106.805ZM12.2333 106.805L14.1274 106.163L13.667 104.805H12.2333V106.805ZM188.767 106.805V104.805H187.333L186.873 106.163L188.767 106.805ZM189 106.805V108.805H191V106.805H189ZM189 19.3354H191V17.3354H189V19.3354ZM187 18.875C187 18.9539 186.996 19.0329 186.987 19.1124L190.962 19.5583C190.987 19.3318 191 19.1039 191 18.875H187ZM100.5 2C124.842 2 146.82 4.10575 162.662 7.48437C170.599 9.17717 176.888 11.1675 181.145 13.3138C183.276 14.3886 184.796 15.4526 185.759 16.4557C186.713 17.4505 187 18.2525 187 18.875H191C191 16.8914 190.048 15.149 188.645 13.6864C187.25 12.2321 185.293 10.9256 182.946 9.74218C178.246 7.37214 171.574 5.29525 163.496 3.57235C147.307 0.119561 125.035 -2 100.5 -2V2ZM14 18.875C14 18.2525 14.2867 17.4505 15.2412 16.4557C16.2036 15.4526 17.7238 14.3886 19.8553 13.3138C24.1117 11.1675 30.4011 9.17717 38.3382 7.48437C54.1797 4.10575 76.1582 2 100.5 2V-2C75.9646 -2 53.6931 0.119561 37.5039 3.57235C29.4256 5.29525 22.7545 7.37214 18.0543 9.74218C15.7074 10.9256 13.7502 12.2321 12.3548 13.6864C10.9515 15.149 10 16.8914 10 18.875H14ZM14.0133 19.1123C14.0044 19.0329 14 18.9539 14 18.875H10C10 19.1039 10.0129 19.3318 10.0383 19.5584L14.0133 19.1123ZM12.0258 17.3354H12V21.3354H12.0258V17.3354ZM10 19.3354V105.424H14V19.3354H10ZM10 105.424V106.805H14V105.424H10ZM12 108.805H12.2333V104.805H12V108.805ZM10.3393 107.447C10.925 109.175 12.2063 110.659 13.8244 111.935C15.4572 113.222 17.5701 114.406 20.0533 115.495C25.021 117.675 31.7293 119.591 39.7072 121.181C55.6819 124.363 77.0554 126.299 100.5 126.299V122.299C77.2454 122.299 56.1436 120.377 40.4888 117.258C32.652 115.696 26.2569 113.85 21.6606 111.833C19.3617 110.824 17.5773 109.8 16.3011 108.794C15.0102 107.776 14.3707 106.88 14.1274 106.163L10.3393 107.447ZM100.5 126.299C123.945 126.299 145.318 124.363 161.293 121.181C169.271 119.591 175.979 117.675 180.947 115.495C183.43 114.406 185.543 113.222 187.176 111.935C188.794 110.659 190.075 109.175 190.661 107.447L186.873 106.163C186.629 106.88 185.99 107.776 184.699 108.794C183.423 109.8 181.638 110.824 179.339 111.833C174.743 113.85 168.348 115.696 160.511 117.258C144.856 120.377 123.755 122.299 100.5 122.299V126.299ZM188.767 108.805H189V104.805H188.767V108.805ZM191 106.805V105.424H187V106.805H191ZM191 105.424V19.3354H187V105.424H191ZM189 17.3354H188.974V21.3354H189V17.3354Z",
    fill: "#FAC515",
    mask: "url(#path-1-inside-1_1105_13150)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188 19C188 19.9737 187.545 21.02 186.478 22.1392C185.407 23.2628 183.778 24.3949 181.593 25.504C177.226 27.7206 170.841 29.7458 162.869 31.4573C146.941 34.8769 124.89 37 100.5 37C76.1101 37 54.0588 34.8769 38.131 31.4573C30.1588 29.7458 23.7744 27.7206 19.4074 25.504C17.2223 24.3949 15.5928 23.2628 14.5219 22.1392C13.4551 21.02 13 19.9737 13 19C13 18.0263 13.4551 16.98 14.5219 15.8608C15.5928 14.7372 17.2223 13.6051 19.4074 12.496C23.7744 10.2794 30.1588 8.25422 38.131 6.54269C54.0588 3.12315 76.1101 1 100.5 1C124.89 1 146.941 3.12315 162.869 6.54269C170.841 8.25422 177.226 10.2794 181.593 12.496C183.778 13.6051 185.407 14.7372 186.478 15.8608C187.545 16.98 188 18.0263 188 19Z",
    stroke: "#FAC515",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1105_13150",
    x: 0,
    y: 0,
    width: 201,
    height: 148.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1105_13150"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1105_13150"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1105_13150"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1105_13150",
    result: "effect2_dropShadow_1105_13150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1105_13150",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSource);
export default __webpack_public_path__ + "static/media/data-source.9ecc93cfe215ca7163d21f15743508c1.svg";
export { ForwardRef as ReactComponent };